import { AxiosResponse } from 'axios';
import PageableRq from '@domain/rq/common/PageableRq';
import { axios } from '@repository/RequestClient';
import { InfoDetailRs } from '@domain/rs/info/InfoDetailRs';
import PostCardListRs from '@domain/rs/post/PostCardListRs';

export default interface PostRepo {
  //콘텐츠 상세 조회
  fetchInfoDetail(postSn: number): Promise<AxiosResponse<InfoDetailRs>>;
  //합격자 게시판 노출 콘텐츠
  fetchPassReviewContents(rq: PageableRq): Promise<AxiosResponse<PostCardListRs>>;
}

export class RemotePostRepo implements PostRepo {
  fetchInfoDetail(postSn: number): Promise<AxiosResponse<InfoDetailRs>> {
    return axios.get<InfoDetailRs>(`/post/${postSn}`);
  }

  fetchPassReviewContents(rq: PageableRq): Promise<AxiosResponse<PostCardListRs>> {
    return axios.get<PostCardListRs>('/post/pass-review', { params: rq });
  }
}
